import React from "react";

const SlideBottomCase = ({ width, rayCount, color, isThreshold, section }) => {
  const height = !isThreshold ? 0.02 : 0.05;
  let posX = 0;
  let caseWidth = width;

  if (section?.left_angle == 90) {
    if (section.sliding_direction == 2 || section.sliding_direction == 3) {//dış birleşim
      posX -= 0.03;
      caseWidth += 0.06;
    } else {
      posX -= 0.07;
      caseWidth += 0.14;
    }
  }

  return (
    <group position={[0, 0, 0]}>
      {/* Tüm kasa ve rayları bu alt grup ile birlikte kaydırıyoruz */}
      <group position={[posX, 0, 0]}>
        {/* Alt ana kasa bloğu */}
        <mesh position={[0, -height / 2, 0]}>
          <boxGeometry args={[caseWidth, height, 0.2]} />
          <meshStandardMaterial color={color} />
        </mesh>

        {/* Raylar */}
        {isThreshold &&
          Array.from({ length: rayCount }).map((_, i) => {
            const x = -0.002 + i * 0.033;
            return (
              <mesh key={i} position={[-posX, 0.001, height - x]}>
                <boxGeometry args={[width, height, 0.005]} />
                <meshStandardMaterial color={color} />
              </mesh>
            );
          })}
      </group>
    </group>
  );
};

export default SlideBottomCase;
